// extracted by mini-css-extract-plugin
export default {"root":"PdfFilesSection_root__LGYTR","loader":"PdfFilesSection_loader__J51dJ"};